import React, { useMemo } from 'react';
import cx from 'clsx';

import { LazyMedia } from '@/components';
import { useTheme } from 'hooks';
import imgDefaultOfficialAccount from 'assets/org/default-official-account.svg';
import imgDefaultOfficialAccountDark from 'assets/org/default-official-account-dark.svg';
import { IconRcBullishLogo, IconBearishLogo } from '@/assets/group';

import style from './index.module.scss';
export interface GroupAvatarProps {
  data?: Group;
  size?: number;
  className?: string;
  onClick?(e: React.MouseEvent<HTMLDivElement>): void;
  logoVisible?: boolean;
  logoSize?: number;
}

export const GroupAvatar = ({
  data,
  size = 64,
  className,
  onClick,
  logoSize = size / 2,
}: GroupAvatarProps) => {
  const { isDark } = useTheme();
  const defaultAvatar = isDark ? imgDefaultOfficialAccountDark : imgDefaultOfficialAccount;
  const isCollection = !!data?.collection;

  const avatarSizeStyle = useMemo(() => ({ width: size, height: size }), [size]);
  const isBullish = useMemo(() => data?.market_opinion === 'bullish', [data?.market_opinion]);

  const logoStyle = useMemo(() => (isBullish ? { top: 0 } : { bottom: 0 }), [isBullish]);

  const avatarImgStyle = useMemo(() => {
    return {
      borderWidth: Math.max(size / 16, 1),
    };
  }, [size]);

  const IconRcLogo = useMemo(() => (isBullish ? IconRcBullishLogo : IconBearishLogo), [isBullish]);

  return (
    <div
      className={cx(style.container, onClick && style.cursor, className)}
      style={avatarSizeStyle}
      onClick={onClick}>
      <LazyMedia
        src={data?.token?.logo_url || data?.collection?.logo_url}
        failedPlaceholder={<img src={defaultAvatar} alt="" />}
        style={avatarImgStyle}
        className={cx(
          style.groupAvatar,
          isCollection && style.isCollection,
          isBullish && style.isBullish,
        )}
      />
      <IconRcLogo width={logoSize} height={logoSize} className={style.logo} style={logoStyle} />
    </div>
  );
};
